import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './styles/common.css'

import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'wowjs/css/libs/animate.css'
import {
  WOW
} from 'wowjs'
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // default
  animateClass: 'animated', // default
  offset: 0, // default
  mobile: true, // default
  live: true, // default
  callback: function (box) {
    console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
  }
})

import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';

Vue.use(VueFullPage);
// Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);
// Vue.use(WOW);

import 'vue-animate-fullpage/dist/animate.css'
import VueAnimateFullpage from 'vue-animate-fullpage/dist/index'
Vue.use(VueAnimateFullpage)

// import animated from 'animate.css' 
import 'animate.css'
// Vue.use(animated)


// 图片转base64格式 挂载在全局
// Vue.prototype.$base64Img = (e) => {
//   return new Promise(function (resolve, reject) { // 使用Promise进行异步处理
//     let fileSize = 0
//     const fileMaxSize = 1024 // 设置图片最大为 1M
//     // fileSize = e.target.files[0].size // 获取图片大小
//     const size = fileSize / 1024
//     const file = e.target.files[0] // 获取图片文件对象
//     const reader = new FileReader() // 实例化一个对象
//     if (size > fileMaxSize) {
//       e.target.value = '' // 内容清空
//       resolve({ err: '图片大小必须小于1M' })
//     } else if (size <= 0) {
//       e.target.value = '' // 内容清空
//       resolve({ err: '图片大小大小不能为0M' })
//     } else {
//       reader.readAsDataURL(file) // 把图片文件对象转换base64
//       reader.onload = function (e) {
//         resolve(e.target.result) // 回到函数返回base64值
//       }
//     }
//   })
// }


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')